// Copyright © 2021 Move Closer
/**
 * This enum is needed for better TypeScript experience
 * within the `Image.stories.ts` file.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var BootstrapImagePropNames;
(function (BootstrapImagePropNames) {
    BootstrapImagePropNames["Fallback"] = "fallback";
})(BootstrapImagePropNames || (BootstrapImagePropNames = {}));
